import { alpha } from "@mui/system"
import { CSSObject } from "tss-react"
import { makeStyles } from "tss-react/mui"
import {
  blueGrey,
  lightBlue,
  teal,
  lightGreen
} from "../../../../../mp-core/themes/palette"
import { SearchItemType } from "../../types"

export const getSearchTypeChipStyles = (
  type: SearchItemType,
  clickable: boolean
): CSSObject => {
  switch (type) {
    case "usersAndGroups": {
      return {
        color: teal[800],
        backgroundColor: teal[50],

        ...(clickable
          ? {
              "&:hover": {
                backgroundColor: alpha(teal[50], 0.5)
              }
            }
          : {})
      }
    }

    case "content": {
      return {
        color: blueGrey[800],
        backgroundColor: lightBlue[50],

        ...(clickable
          ? {
              "&:hover": {
                backgroundColor: alpha(lightBlue[50], 0.5)
              }
            }
          : {})
      }
    }

    case "standards": {
      return {
        color: blueGrey[800],
        backgroundColor: blueGrey[50],

        ...(clickable
          ? {
              "&:hover": {
                backgroundColor: alpha(blueGrey[50], 0.5)
              }
            }
          : {})
      }
    }

    case "views": {
      return {
        color: lightGreen[900],
        backgroundColor: lightGreen[100],

        ...(clickable
          ? {
              "&:hover": {
                backgroundColor: alpha(lightGreen[100], 0.5)
              }
            }
          : {})
      }
    }
  }
}

export const useStyles = makeStyles<{
  type: SearchItemType
  clickable: boolean
}>()(({ palette }, { type, clickable }) => ({
  globalSearchItemChip: {
    ...(clickable ? { cursor: "pointer" } : {}),
    ...getSearchTypeChipStyles(type, clickable)
  },
  globalSearchItemChipNotSelected: {
    color: blueGrey[500],
    backgroundColor: palette.common.white,
    borderRadius: "100px",
    border: `1px solid ${blueGrey[100]}`
  }
}))
